import { Injectable } from '@angular/core';
import { Socket } from 'ngx-socket-io';
import { Subject } from 'rxjs';
import { User_Socket } from '../../interfaces/user';

@Injectable({
  providedIn: 'root'
})
export class SocketService {

  // Creamos un Subject para el evento de conexión
  private connectSub = new Subject<any>();
  public connect$ = this.connectSub.asObservable();
  
  //Recibir el gps del chofer en una ruta activa
  private onGpsRutaActSub = new Subject<any[]>();
  public onGpsRutaAct$ = this.onGpsRutaActSub.asObservable();

  //Solicita al chofer en una ruta activa
  private getGpsRutaActSub = new Subject<any[]>();
  public getGpsRutaAct$ = this.getGpsRutaActSub.asObservable();

  private despacharSub = new Subject<any>();
  public despachar$ = this.despacharSub.asObservable();

  private finalizarRutaSub = new Subject<any>();
  public finalizarRuta$ = this.finalizarRutaSub.asObservable();

  private pass = {
    login_user: true
  };

  constructor(private socket: Socket) {
    // Escuchamos los eventos del socket UNA SOLA VEZ
    this.socketEvents();
  }

  private socketEvents() {
    this.socket.fromEvent('connect').subscribe(() => {
      console.log('Servicio de Socket: Conexión exitosa.');
      this.connectSub.next(true);
    });

    // this.socket.fromEvent('login_user').subscribe((msg) => {
    //   this.pass.login_user = true;
    // });

    this.socket.fromEvent('send_gps_chofer_ruta_activa').subscribe((data:any) => {
      this.onGpsRutaActSub.next(data);
    });

    this.socket.fromEvent('get_gps_chofer_ruta_activa').subscribe((data:any) => {
      this.getGpsRutaActSub.next(data);
    });

    this.socket.fromEvent('despachar').subscribe((data: any) => {
      this.despacharSub.next(data);
    });

    this.socket.fromEvent('finalizar_ruta').subscribe((data: any) => {
      this.finalizarRutaSub.next(data);
    });

    this.socket.fromEvent('disconnect').subscribe(() => {
      console.log('Servicio de Socket: Desconexión.');
      this.connectSub.next(false);
    });
  }

  // Guarda los datos del usuario y lo activa para recibir y enviar eventos
  public loginUser(auth: any): void {
    // if(this.pass.login_user){
    //   this.pass.login_user = false;
      const datosUsuario = {
        pk: auth.user.idusuario,
        dni: auth.user.dni,
        first_name: auth.user.nombre_user,
        last_name: auth.user.apellido_user,
        fullname: `${auth.user.nombre_user} ${auth.user.apellido_user}`,
        correo_user: auth.user.correo_user,
        tlf_user: auth.user.tlf_user,
        activo_user: auth.user.activo_user,
        idsucursal: auth.user.idsucursal,
      };
      this.socket.emit('login_user', { token: auth.get_token(), user: datosUsuario as User_Socket });
    // }else{
    //   setTimeout(() => {
    //     this.loginUser(auth);
    //   }, 100);
    // }
  }

  public logoutUser(): void {
    this.socket.emit('logout_user');
  }

  public logoutSocket(): void {
    this.socket.emit('logout_socket');
  }

  //El chofer envia su gps de la ruta activa
  public sendGpsRutaAct(data:any): void {
    this.socket.emit('send_gps_chofer_ruta_activa', data, (resp) => {
      if (!resp.success) {
        // Manejar el error
      }
    });
  }

  //Se solicita el gps de un determinado chofer 
  public getGpsRutaAct(data:any): void {
    this.socket.emit('get_gps_chofer_ruta_activa', data, (resp) => {
    });
  }

  public joinRutaAct(data:any): void {
    this.socket.emit('tracking_in_ruta_act', data);
  }

  public leaveRutaAct(data:any): void {
    this.socket.emit('tracking_out_ruta_act', data);
  }

  public despachar(data: any): void {
    this.socket.emit('despachar', data);
  }

  public finalizarRuta(data: any): void {
    this.socket.emit('finalizar_ruta', data);
  }
  
}
